$(function () {
    const scrolled = function () {
        if ($(".reglog").length > 0) {
            var d = $(".reglog").offset();
            if (d.top > 50) {
               $(".reglog").addClass('scrolled');
            } else {
               $(".reglog").removeClass('scrolled');
            }
        }
    }
    const touchTest = function () {
        $('html').removeClass('touch');
        $('html').removeClass('no-touch');
            document.documentElement.className +=
                (("ontouchstart" in document.documentElement) ? ' touch' : ' no-touch');
    }

    //----------------------------------------------Nav    -------------------------------------------------------------------//
    const fixMenu = function (){
        if ($(window).width() >= 992) {
            if ($(window).height() <= 768){
                $('nav.navbar').removeClass('fixed-top');
            } else {
                $('nav.navbar').addClass('fixed-top');
            }
        }
    }
    const mobileNavOpen = function () {
        if ($(window).width() <= 992 || ('ontouchstart' in document.documentElement)) {
            $('.hasChild > a').click(function (e) {
                if ($(this).next('.subnav-cover').length > 0) {
                    e.preventDefault();
                    var $item = $(this).next('.subnav-cover').toggleClass('d-table');
                    $('.subnav-cover').not($item).removeClass('d-table');
                    return false;
                }
            })
        } else {
            $('.subnav-cover').removeClass('d-table');
        }
    }

    //----------------------------------------------Nav End-------------------------------------------------------------------//

    /*
    $('#datepicker').datepicker({
        weekStart: 1,
        todayBtn: "linked",
        clearBtn: true,
        todayHighlight: true
    });
    */
    /*---------------------------------------------- Sticky side bar -----------------------------------------------------------*/

    if ($('.sticky-scroll-box').length > 0) {
        var top = $('.sticky-scroll-box').offset().top;
        $('.sticky-scroll-box').parent().css('position', 'relative');
        $(window).scroll(function (event) {
            if ($(window).width() > 768) {
                var y = $(this).scrollTop();
                if (y >= top)
                    $('.sticky-scroll-box').addClass('fixed');
                else
                    $('.sticky-scroll-box').removeClass('fixed');
                $('.sticky-scroll-box').width($('.sticky-scroll-box').parent().width());
            }
        });
        $(window).resize(function () {
            $('.sticky-scroll-box').width($('.sticky-scroll-box').parent().width());
            if ($(window).width() < 768) {
                $('.sticky-scroll-box').removeClass('fixed');
            }
        })
    }
    /*---------------------------------------------- Sticky side bar END -----------------------------------------------------------*/

    /*----------------------------------------------Accouring List animation go top -------------------------------------------  */
    //const cardCollapse = function () {

    //    $('.card .collapse').on('shown.bs.collapse', function (e) {
    //        var $panel = $(this).closest('.map-items');
    //        $('html,body').animate({
    //            scrollTop: $panel.offset().top - 100
    //        }, 500);
    //    });

    //}
    //cardCollapse();
    //$('.btn-group-toggle').click(function () {
    //    cardCollapse();
    //})
    const goToMap = function (e) {
        if ($(window).width() > 992) {
            $('html,body').animate({
                scrollTop: $(e).offset().top - 140
            }, 500);
        } else {
            $('html,body').animate({
                scrollTop: $(e).offset().top - 70
            }, 500);
        }
    }
       
    const collapseProductList = function () {
        $('.card .collapse').on('hidden.bs.collapse', function () {
            $(this).parent().removeClass('box__shadow');
        });
        $('.card .collapse').on('show.bs.collapse', function () {
            $(this).parent().addClass('box__shadow');
        });
    };
    collapseProductList();
    
    /*----------------------------------------------Accouring List animation go top END -------------------------------------------  */

    //----------------------------------------------Our Team-------------------------------------------------------------------//

    $('[data-map]').hover(function () {
        var e = $(this).data('map');
        $('button[data-map]').removeClass('hovered');
        $('g[data-map]').removeClass('hovered');

        $('button[data-map = ' + e + ']').addClass('hovered');
        $('g[data-map = ' + e + ']').addClass('hovered');
    }
        , function () {
            var e = $(this).data('map');
            $('button[data-map = ' + e + ']').removeClass('hovered');
            $('g[data-map = ' + e + ']').removeClass('hovered');
        }
    )

    $('[data-map]').click(function () {
        $('[data-map-details]').removeClass('active');
        $('[data-map]').removeClass('active');
        var e = $(this).data('map');
        $('button[data-map = ' + e + ']').addClass('active');
        $('[data-map-details = ' + e + ']').addClass('active');
        $('g[data-map = ' + e + ']').addClass('active');
        goToMap('#map');
    })

    $('button.close').click(function () {
        $('button[data-map]').removeClass('active');
        $('[data-map-details]').removeClass('active');
        $('g[data-map]').removeClass('active');
        goToMap('#map');
    })

    $(document).click(function (e) {
        if ($(e.target).closest('#map svg g.group').length === 0 && $(e.target).closest('#map .map-items').length === 0) {
            $('button[data-map]').removeClass('active');
            $('[data-map-details]').removeClass('active');
            $('g[data-map]').removeClass('active');
        }
    });

    //----------------------------------------------Our Team End-------------------------------------------------------------------//


    //----------------------------------------------Nav Search---------------------------------------------------------------------//

    $('button.nav-open-search').on('click', function () {
        $('.nav-search').toggleClass('active');
        $('html').toggleClass('open-search');

    })

    $('.nav-search button.closeSearch').on('click', function () {
        $('.nav-search').toggleClass('active');
        $('html').toggleClass('open-search');
    })

    $('.nav-search input').keydown(function (e) {
        var code = e.which;
        if (code === 13) {
            e.preventDefault();
            var $input = $(this);
            var url = $input.data('url') || '';
            var searchTerm = $input.val();
            window.location = url.replace('{0}', searchTerm);
        }
    });

    //----------------------------------------------Nav Search End-----------------------------------------------------------------//

    // $('[data-toggle="popover"]').popover({trigger: 'focus'})

    $('#navbarNavDropdown').on('show.bs.collapse', function () {
        $('body').addClass('menu-active')
    })

    $('#navbarNavDropdown').on('hide.bs.collapse', function () {
        $('body').removeClass('menu-active')
    })

    const underLineText = function () {

        $('.title-underline').each(function () {

            const lh = parseFloat($(this).css('line-height'));
            const headbefore = $(this).children('.under-line');

            headbefore.css('top', lh * 0.75)

        })
    }
    const boxlightgray = function (e, f) {
        if ($(window).width() >= 768) {
            $(e, this).each(function () {
                //container
                $(f, this).height('auto');
                var highestBox = 0;
                $(f, this).each(function () {
                    //column
                    if ($(this).height() > highestBox) {
                        highestBox = $(this).height();
                    }
                });
                $(f, this).height(highestBox);
            });
        } else {
            $(f, this).height('auto');
        }
    };
    var highestSlider = function boxlightgray(e, f) {
        $(e, this).each(function () {
            //container
            $(f, this).height('auto');
            var highestBox = 0;
            $(f, this).each(function () {
                //column
                if ($(this).height() > highestBox) {
                    highestBox = $(this).height();
                }
            });
            $(f, this).height(highestBox);
        });
    };


    const homeLending = function () {
        if ($('.home-subtitle').length > 0) {
            const lh = $('.knockout-text-two').offset();
            const h = $('.knockout-text-two').height();
            $('.home-subtitle').css('top', lh.top + h)
        }
    };
    const overflowText = function (e) {
        //if ($(e).length > 0){
        if ($(window).width() >= 768) {
            const h = $(e).outerHeight(true);
            $(e).css('position', 'absolute');
            $(e).next('.row').children().css('padding-top', h);
        } else {
            $(e).css('position', 'relative');
            $(e).next('.row').children().css('padding-top', 0);
        }
        //}
    };

    $('.flipcard button').click(function(){
        $(this).parent().parent().toggleClass('active')
    })

    touchTest();
    fixMenu();
    mobileNavOpen();
    boxlightgray('.row', '.box .h4');
    boxlightgray('.row', '.box .h3');
    boxlightgray('.row', '.box__news .h5');
    if ($('.box .content').length > 0) {
        boxlightgray('.row', '.box .content');
    } else {
        boxlightgray('.row', '.box p');
    }
    boxlightgray('.row', '.box p.date');
    underLineText();
    //homeLending();
    overflowText('.overflow-text');

    setTimeout(function () {
        highestSlider('.carousel-inner', '.carousel-item');
    }, 500);

    $(window).scroll(function () {
        scrolled();
    });

    $(window).resize(function () {
        touchTest();
        fixMenu();
        mobileNavOpen();
        boxlightgray('.row', '.box .h4');
        boxlightgray('.row', '.box .h3');
        boxlightgray('.row', '.box__news .h5');
        highestSlider('.carousel-inner', '.carousel-item');

        if ($('.box .content').length > 0) {
            boxlightgray('.row', '.box .content');
        } else {
            boxlightgray('.row', '.box p');
        }

        boxlightgray('.row', '.box p.date');
        underLineText();
        //homeLending();
        overflowText('.overflow-text');
        scrolled();
    });


    (function () {
        if (window.parent != window) {
            document.body.classList.add('embedded-in-iframe');

            var form1 = document.getElementById('form1');
            var reportSize = function () {
                var getParent = function () { return window.parent; };
                getParent().postMessage({ form1: form1.getBoundingClientRect() }, location.origin);
            };

            const resizeObserver = new ResizeObserver(function () {
                reportSize();
            });

            resizeObserver.observe(form1);

            window.addEventListener('resize', reportSize);
            form1.addEventListener('change', reportSize);
            setTimeout(function () {
                reportSize();
            }, 0);
        }
    })();

});